import htmx from 'htmx.org';
window.htmx = htmx;

import '@github/details-menu-element';

import BlogMeta from './components/BlogMeta/BlogMeta.js';
import Modal from './components/Modal/Modal.js';
import NewsletterForm from './components/NewsletterForm/NewsletterForm.js';
import AjaxForm from './components/AjaxForm/AjaxForm.js';
import FacetsDropdown from './components/FacetsDropdown/FacetsDropdown.js';
import ActiveFilters from './components/ActiveFilters/ActiveFilters.js';

window.addEventListener('load', () => {
    const meta = document.querySelector('.c-blog-meta');

    if (meta) {
        new BlogMeta(meta);
    }

    document.querySelectorAll('.c-modal').forEach(element => new Modal(element));
    document.querySelectorAll('.c-newsletter-form').forEach(element => new NewsletterForm(element));
    document.querySelectorAll('.c-facets-dropdown').forEach(element => new FacetsDropdown(element));
});

window.addEventListener('htmx:load', () => {
    document.querySelectorAll('[data-ajax-form]').forEach(element => new AjaxForm(element));
    document.querySelectorAll('.c-active-filters').forEach(element => new ActiveFilters(element));
});
